import { render, staticRenderFns } from "./ConsultationsManage.vue?vue&type=template&id=eba3fc90&scoped=true"
import script from "./ConsultationsManage.vue?vue&type=script&lang=js"
export * from "./ConsultationsManage.vue?vue&type=script&lang=js"
import style0 from "./ConsultationsManage.vue?vue&type=style&index=0&id=eba3fc90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eba3fc90",
  null
  
)

export default component.exports